__turbopack_context__.v({
  "enterYourEmail": "input-field-module-scss-module__S116XW__enterYourEmail",
  "error": "input-field-module-scss-module__S116XW__error",
  "errorMessage": "input-field-module-scss-module__S116XW__errorMessage",
  "inputField": "input-field-module-scss-module__S116XW__inputField",
  "label": "input-field-module-scss-module__S116XW__label",
  "row": "input-field-module-scss-module__S116XW__row",
});
